<template>
  <v-container :class="cardContainerClass" :style="loadCustomCardStyle" v-if="producao">
    <v-row :class="cardContentClass">
      <v-col>
        <v-row :class="cardFooterClass">
          <v-col class="d-flex align-center pl-4 pr-0 pb-2 pt-0">
            <template v-if="content.flg_sem_avatar === 'N'">
              <v-avatar :width="avatarSize" :height="avatarSize">
                <v-img :src="content.url_avatar_colaborador" alt="Avatar" />
              </v-avatar>
            </template>
            <template v-else>
              <v-avatar :width="avatarSize" :height="avatarSize">
                <v-img src="@/assets/User.png" alt="Avatar" />
              </v-avatar>
            </template>
            <template v-if="!fullscreen">
              <h4 class="ml-3 font-weight-regular">
                {{
                  content.dsc_nome_colaborador &&
                  content.dsc_uf_colaborador &&
                  flgExibirUf
                    ? `${content.dsc_nome_colaborador} - ${content.dsc_uf_colaborador}`
                    : content.dsc_nome_colaborador
                    ? `${content.dsc_nome_colaborador}`
                    : ""
                }}
              </h4>
            </template>
            <template v-else>
              <h3 class="ml-3 font-weight-regular">
                {{
                  content.dsc_nome_colaborador &&
                  content.dsc_uf_colaborador &&
                  flgExibirUf
                    ? `${content.dsc_nome_colaborador} - ${content.dsc_uf_colaborador}`
                    : content.dsc_nome_colaborador
                    ? `${content.dsc_nome_colaborador}`
                    : ""
                }}
              </h3>
            </template>
            <h6
              class="ml-1 text-subtitle-1"
              v-if="
                ['twitter', 'bluesky', 'threads'].includes(content.dsc_fonte_colaboracao)
              "
            >
              - {{ content.dsc_colaborador_user }}
            </h6>
          </v-col>
          <v-col
            class="fonte-wrapper pt-0 pb-2 pr-0 d-flex align-center flex-shrink-1 flex-grow-0"
          >
            <FormatedIcon
              :class="fullscreen ? 'ml-auto' : 'ml-auto'"
              :fonte_colaboracao="content.dsc_fonte_colaboracao"
              :card_background_color="cardConfig?.dscCorCard"
            />
          </v-col>
        </v-row>

        <v-row :class="cardTextClass">
          <template v-if="!fullscreen">
            <h3
              v-if="
                content.dsc_texto_colaboracao.trim() !== '' && content.flg_exibir_texto
              "
              class="pt-3 px-4"
              :class="cardTextFontSizeClass"
            >
              {{
                content.dsc_texto_colaboracao.length > 220
                  ? content.dsc_texto_colaboracao.substr(0, 220) + "..."
                  : content.dsc_texto_colaboracao
              }}
            </h3>
            <div
              style="width: 100%"
              class="d-flex align-center justify-center"
              v-if="content.dsc_tipo_midia_colaboracao === 'audio'"
            >
              <audio
                style="width: 100%"
                class="mt-4 px-4"
                controls
                :key="content.url_midia_colaboracao"
              >
                <source :src="content.url_midia_colaboracao" />
              </audio>
            </div>
          </template>
          <template v-else>
            <h2
              v-if="
                content.dsc_texto_colaboracao.trim() !== '' && content.flg_exibir_texto
              "
              class="pt-3 px-4 font-weight-bold"
              :class="cardTextFontSizeClass"
            >
              {{ content.dsc_texto_colaboracao }}
            </h2>
            <div
              style="width: 100%"
              class="d-flex align-center"
              v-if="content.dsc_tipo_midia_colaboracao === 'audio'"
            >
              <audio
                style="width: 100%"
                class="mt-4"
                controls
                :key="content.url_midia_colaboracao"
              >
                <source :src="content.url_midia_colaboracao" />
              </audio>
            </div>
          </template>
        </v-row>
        <v-row>
          <div class="d-flex align-center justify-end" style="width: 100%">
            <MarkAsReadButton
              :is-at-mosaico-view="true"
              :colab-data="content"
              :is-at-card-mosaico="true"
              :icon-color="cardConfig?.dscCorFonte"
            />
          </div>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-if="
        !fullscreen &&
        colaboracaoContemMidia() &&
        content.dsc_tipo_midia_colaboracao !== 'audio'
      "
      class="card-media py-0"
    >
      <template v-if="content.dsc_tipo_midia_colaboracao === 'image'">
        <!-- <div class="d-flex align-center justify-end" style="width: 100%;">
                    <MarkAsReadButton :colab-data="content" :is-at-card-mosaico="true" :icon-color="cardConfig?.dscCorFonte" />
                </div> -->
        <v-img
          width="100%"
          height="100%"
          :src="content.url_midia_colaboracao"
          alt="Imagem"
        />
      </template>
      <template v-if="content.dsc_tipo_midia_colaboracao === 'video'">
        <!-- <div class="d-flex align-center justify-end" style="width: 100%;">
                    <MarkAsReadButton :colab-data="content" :is-at-card-mosaico="true" :icon-color="cardConfig?.dscCorFonte" />
                </div> -->
        <v-img
          :src="content.url_midia_thumbnail"
          alt="Imagem Thumbnail"
          width="100%"
          height="100%"
        >
          <v-icon
            size="56px"
            class="text-center"
            style="position: absolute; color: white; top: 42%; left: 42%"
          >
            mdi-play
          </v-icon>
        </v-img>
      </template>
    </v-row>

    <v-row
      v-if="fullscreen && colaboracaoContemMidia()"
      class="card-media-fullscreen py-0"
    >
      <template v-if="content.dsc_tipo_midia_colaboracao === 'image'">
        <v-img
          :src="content.url_midia_colaboracao"
          contain
          width="100%"
          height="100%"
          alt="Imagem"
        />
      </template>
      <template v-if="content.dsc_tipo_midia_colaboracao === 'video'">
        <video
          :key="content.url_midia_colaboracao"
          ref="videoPlayer"
          width="100%"
          height="100%"
          controls
          autoplay
          @playing="() => this.$emit('played', this.$refs.videoPlayer)"
        >
          <source :src="content.url_midia_colaboracao" type="video/mp4" />
        </video>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import FormatedIcon from "../FormatedIcon.vue";
import MarkAsReadButton from "../Colaboracoes/MarkAsReadButton.vue";

export default {
  props: {
    content: {
      type: Object,
    },
    producao: {
      type: Object,
    },
    flgExibirUf: {
      type: Boolean,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    cardConfig: {
      type: Object,
      default: null,
    },
    mosaicoType: {
      type: Number, // 0 => coluna, 1 => galeria
      default: 1,
    },
  },
  components: { FormatedIcon, MarkAsReadButton },
  methods: {
    colaboracaoContemMidia() {
      if (this.content.dsc_tipo_midia_colaboracao) {
        if (this.content.dsc_tipo_midia_colaboracao === "audio") {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  },
  computed: {
    cardContainerClass() {
      const cardTemMidia = this.colaboracaoContemMidia() ? "" : "-no-media";
      const styleClasses = ["d-flex"];
      const cardMediaContainerClass = this.fullscreen
        ? "card-media-container-fullscreen"
        : "card-media-container";
      const cardContainerClass = this.fullscreen
        ? `card-container-fullscreen${cardTemMidia}`
        : "card-container";

      if (!this.cardConfig) {
        const isDarkTheme = localStorage.getItem("@socialcam/is_dark_theme");
        isDarkTheme === "true"
          ? styleClasses.push("darkThemeStyle")
          : styleClasses.push("lightThemeStyle");
      }

      styleClasses.push(cardContainerClass);
      this.colaboracaoContemMidia() ? styleClasses.push(cardMediaContainerClass) : null;

      return styleClasses;
    },
    cardContentClass() {
      const cardContentClass = this.fullscreen
        ? "card-content-fullscreen"
        : "card-content";
      // const modoColunaFlexClass = this.mosaicoType === 0 ? 'flex-grow-0' : ''
      return ["d-flex", cardContentClass];
    },
    cardTextClass() {
      const cardTextClass = this.fullscreen
        ? "card-content__text-fullscreen"
        : "card-content__text";
      return [cardTextClass];
    },
    cardFooterClass() {
      const cardFooterClass = this.fullscreen
        ? "card_content__footer-fullscreen"
        : "card_content__footer";
      return ["d-flex", "v-col-auto", cardFooterClass];
    },
    cardTextFontSizeClass() {
      const fontClass = this.producao.dsc_font_size_texto_mosaico;
      const screenWidth = this.$vuetify.breakpoint.width;
      const values = {
        "text-h6": "text-subtitle-1",
        "text-h5": "text-h6",
        "text-h4": "text-h5",
      };
      return this.fullscreen &&
        screenWidth < 600 &&
        this.content.url_midia_colaboracao &&
        this.content.dsc_texto_colaboracao.length > 150
        ? "text-subtitle-1"
        : this.content.dsc_texto_colaboracao.length < 500
        ? fontClass
        : this.content.dsc_texto_colaboracao.length >= 500
        ? values[fontClass]
        : "text-h5";
    },
    avatarSize() {
      return this.fullscreen ? 64 : 48;
    },
    loadCustomCardStyle() {
      return this.cardConfig
        ? { background: this.cardConfig?.dscCorCard, color: this.cardConfig?.dscCorFonte }
        : {};
    },
  },
};
</script>
<style lang="scss" scoped>
$card-content-height: 335px;
$card-content-vertical-max-width: 438px;
$text-vertical-content: 215px;
$footer-content: $card-content-height - $text-vertical-content;

$card-content-height-fullscreen: 454px;
$card-content-vertical-max-width-fullscreen: 900px;
$text-vertical-content-fullscreen: 260px;
$footer-content-fullscreen: $card-content-height-fullscreen -
  $text-vertical-content-fullscreen;

.card-container {
  height: 335px;
  width: 470px;
  flex-direction: column;
  border-radius: 0px;

  @media screen and (max-width: 600px) {
    width: 370px;
  }

  margin: 0;
  padding: 0;

  &-fullscreen {
    height: 40%;
    width: 90%;

    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  &-fullscreen-no-media {
    height: 50%;
    width: 65%;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
}

.card-media-container {
  height: 680px;

  &-fullscreen {
    height: 95%;
    flex-direction: column;

    @media (max-width: 56rem) {
      height: 80%;
    }
  }
}

.card-media {
  height: 308px;

  &-fullscreen {
    height: 60%;
    align-content: center;

    @media screen and (max-width: 600px) {
      height: 50%;
      align-content: center;
    }
  }
}

.card-content {
  max-height: $card-content-height;

  .fonte-wrapper {
    padding-left: 4px;
  }

  &__text {
    width: $card-content-vertical-max-width;
    height: $text-vertical-content;
    font-weight: 700;
    text-align: left;
    overflow: hidden;

    @media screen and (max-width: 600px) {
      width: 350px;
      height: 150px;
    }

    h3 {
      overflow-y: auto;
      text-overflow: ellipsis;
      word-wrap: break-word;
    }

    &-fullscreen {
      height: 70%;

      @media screen and (max-width: 600px) {
        height: 60%;
      }

      h2 {
        overflow-y: auto;
        text-overflow: ellipsis;
        word-wrap: break-word;
      }
    }
  }

  &__footer {
    width: $card-content-vertical-max-width;
    height: $footer-content;

    &-fullscreen {
      width: 90%;
      height: 30%;
    }
  }
}

.row {
  margin: 0;
}

@media only screen and (min-width: 1024px) and (max-width: 1180px) and (min-height: 768px) and (max-height: 820px) {
  .card-container {
    height: 335px;
    width: 470px;
    flex-direction: column;
    border-radius: 0px;

    margin: 0;
    padding: 0;

    &-fullscreen {
      height: 50%;
      width: 90%;
    }

    &-fullscreen-no-media {
      height: 55%;
      width: 75%;
    }
  }
  .card-media {
    height: 308px;

    &-fullscreen {
      height: 60%;
      align-content: center;
    }
  }
  .card-media-container {
    height: 680px;

    &-fullscreen {
      height: 95%;
      flex-direction: column;

      @media (max-width: 56rem) {
        height: 80%;
      }
    }
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1366px) and (min-height: 768px) and (max-height: 768px) {
  .card-container {
    height: 335px;
    width: 470px;
    flex-direction: column;
    border-radius: 0px;

    margin: 0;
    padding: 0;

    &-fullscreen {
      height: 50%;
      width: 90%;
    }

    &-fullscreen-no-media {
      height: 55%;
      width: 75%;
    }
  }
  .card-media {
    height: 308px;

    &-fullscreen {
      height: 60%;
      align-content: center;
    }
  }
  .card-media-container {
    height: 680px;

    &-fullscreen {
      height: 95%;
      flex-direction: column;

      @media (max-width: 56rem) {
        height: 80%;
      }
    }
  }
}
</style>
